// NBN Edit Form Constants
// Static data that doesn't need to be reactive

import {
  includeCurrentSelectValue,
  NTD_MODIFICATION_OPTIONS
} from "./nbn-order-item-constants";

export const CONTRACT_TERMS = [
  { text: "M2M", value: "M2M", disabled: false },
  { text: "12 Months", value: "12", disabled: false },
  { text: "24 Months", value: "24", disabled: false }
];

export const BANDWIDTH_PROFILES = {
  NCAS: [
    { text: "12/1 Mbps", value: "D12_U1_Mbps_TC4_P", disabled: false },
    { text: "25/5 Mbps", value: "D25_U5_Mbps_TC4_P", disabled: false },
    { text: "25/10 Mbps", value: "D25_U5-10_Mbps_TC4_P", disabled: false },
    { text: "50/20 Mbps", value: "D25-50_U5-20_Mbps_TC4_P", disabled: false },
    { text: "100/20 Mbps", value: "Home Fast", disabled: false },
    {
      text: "100/40 Mbps",
      value: "D25-100_U5-40_Mbps_TC4_P",
      disabled: false
    }
  ],

  NWAS: [
    { text: "12/1 Mbps", value: "D12_U1_Mbps_TC4_P", disabled: false },
    { text: "25/5 Mbps", value: "D25_U5_Mbps_TC4_P", disabled: false },
    { text: "FW Plus", value: "FWPlus_TC4_P", disabled: false },
    { text: "250/20 Mbps", value: "FW Home Fast", disabled: false },
    { text: "400/40 Mbps", value: "FW Superfast", disabled: false }
  ],

  NHAS: [
    { text: "12/1 Mbps", value: "D12_U1_Mbps_TC4_P", disabled: false },
    { text: "25/5 Mbps", value: "D25_U5_Mbps_TC4_P", disabled: false },
    { text: "25/10 Mbps", value: "D25_U10_Mbps_TC4_P", disabled: false },
    { text: "50/20 Mbps", value: "D50_U20_Mbps_TC4_P", disabled: false },
    { text: "100/40 Mbps", value: "D100_U40_Mbps_TC4_P", disabled: false },
    { text: "250/100 Mbps", value: "D250_U100_Mbps_TC4_P", disabled: false },
    { text: "500/50 Mbps", value: "Home Fast", disabled: false },
    { text: "750/50 Mbps", value: "Home Superfast", disabled: false },
    { text: "1000/100 Mbps", value: "Home Ultrafast", disabled: false }
  ],

  NFAS: [
    { text: "12/1 Mbps", value: "D12_U1_Mbps_TC4_P", disabled: false },
    { text: "25/5 Mbps", value: "D25_U5_Mbps_TC4_P", disabled: false },
    { text: "25/10 Mbps", value: "D25_U10_Mbps_TC4_P", disabled: false },
    { text: "50/20 Mbps", value: "D50_U20_Mbps_TC4_P", disabled: false },
    { text: "100/40 Mbps", value: "D100_U40_Mbps_TC4_P", disabled: false },
    { text: "250/100 Mbps", value: "D250_U100_Mbps_TC4_P", disabled: false },
    { text: "500/50 Mbps", value: "Home Fast", disabled: false },
    { text: "500/200 Mbps", value: "D500_U200_Mbps_TC4_P", disabled: false },
    { text: "750/50 Mbps", value: "Home Superfast", disabled: false },
    { text: "1000/100 Mbps", value: "Home Ultrafast", disabled: false },
    {
      text: "1000/400 Mbps",
      value: "D1000_U400_Mbps_TC4_P",
      disabled: false
    }
  ]
};

export const FTTC_BANDWIDTH_PROFILES = {
  SOG6028_ENABLED: [
    { text: "12/1 Mbps", value: "D12_U1_Mbps_TC4_P", disabled: false },
    { text: "25/5 Mbps", value: "D25_U5_Mbps_TC4_P", disabled: false },
    { text: "25/10 Mbps", value: "D25_U10_Mbps_TC4_P", disabled: false },
    { text: "50/20 Mbps", value: "D50_U20_Mbps_TC4_P", disabled: false },
    { text: "100/20 Mbps", value: "Home Fast", disabled: false },
    {
      text: "100/40 Mbps",
      value: "D50-100_U20-40_Mbps_TC4_P",
      disabled: false
    },
    {
      text: "50/20 Mbps",
      value: "D25-50_U5-20_Mbps_TC4_P",
      disabled: false,
      obsolete: true
    }
  ],
  DEFAULT: [
    { text: "12/1 Mbps", value: "D12_U1_Mbps_TC4_P", disabled: false },
    { text: "25/5 Mbps", value: "D25_U5_Mbps_TC4_P", disabled: false },
    {
      text: "25/10 Mbps",
      value: "D25_U5-10_Mbps_TC4_P",
      disabled: false
    },
    {
      text: "50/20 Mbps",
      value: "D25-50_U5-20_Mbps_TC4_P",
      disabled: false
    },
    { text: "100/20 Mbps", value: "Home Fast", disabled: false },
    {
      text: "100/40 Mbps",
      value: "D25-100_U5-40_Mbps_TC4_P",
      disabled: false
    }
  ]
};

// Form field configuration
export const FORM_FIELDS = {
  customerFirstname: {
    label: "Customer Firstname",
    validation: "required"
  },
  customerSurname: {
    label: "Customer Surname",
    validation: "required"
  },
  customerContactEmail: {
    label: "Customer Email",
    validation: "required|email"
  },
  customerContactNumber: {
    label: "Customer Contact No.",
    validation: "required|custcontactnumber"
  },
  contractTerm: {
    label: "Contract Term",
    validation: "required"
  },
  bandwidthProfile: {
    label: "Bandwidth Profile",
    validation: "required"
  },
  radiusUsername: {
    label: "Radius Username",
    validation: "required"
  },
  radiusPassword: {
    label: "Radius Password",
    validation: "required"
  },
  wholesalerAccountNumber: {
    label: "Wholesaler Account Number",
    validation: "required"
  },
  customerAuthRef: {
    label: "Customer Auth Ref.",
    validation: "required"
  },
  ntdType: {
    label: "NTD Type",
    validation: ""
  },
  productTemplate: {
    label: "Product Template",
    validation: ""
  },
  ntdId: {
    label: "NTD Id",
    validation: ""
  },
  ntdModifications: {
    label: "NTD Modification",
    validation: ""
  }
};

export const EDIT_FORM_NTD_TYPES = [
  "1_PORT",
  "4_PORT",
  "INTERNAL",
  "NTD_2.5",
  "Internal"
];

export const EDIT_FORM_SPECIAL_NTD_IDS = [
  "NTD Installation Required",
  "Additional NTD Required",
  "Additional Line Installation"
];

export function buildEditFormNtdTypeOptions(current) {
  return includeCurrentSelectValue(EDIT_FORM_NTD_TYPES, current);
}

export function buildEditFormNtdModificationOptions(current) {
  return includeCurrentSelectValue(
    Object.values(NTD_MODIFICATION_OPTIONS),
    current
  );
}

export function buildEditFormNtdIdOptions(supportingResources, current) {
  const ids = (supportingResources || [])
    .map(resource => resource && resource.id)
    .filter(id => id != null && String(id).trim() !== "");
  return includeCurrentSelectValue(
    [...new Set([...ids, ...EDIT_FORM_SPECIAL_NTD_IDS])],
    current
  );
}

export function includeCurrentTemplateOption(templates, current) {
  const list = Array.isArray(templates) ? [...templates] : [];
  if (current == null || String(current).trim() === "") return list;
  if (list.some(template => template.value === current)) return list;
  return [...list, { text: current, value: current, disabled: false }];
}

// Helper function to get bandwidth profiles by product type
export function getBandwidthProfilesByProductType(productType) {
  switch (productType) {
    case "FTTB":
    case "FTTN":
      return BANDWIDTH_PROFILES.NCAS;
    case "Fixed Wireless":
      return BANDWIDTH_PROFILES.NWAS;
    case "HFC":
      return BANDWIDTH_PROFILES.NHAS;
    case "FTTC":
      return FTTC_BANDWIDTH_PROFILES.DEFAULT; // Will be overridden by computed property
    case "Fibre":
    case "FTTP":
      return BANDWIDTH_PROFILES.NFAS;
    default:
      return [];
  }
}

// Helper function to get FTTC bandwidth profiles based on feature flag
export function getFTTCBandwidthProfiles(isSOG6028Enabled) {
  return isSOG6028Enabled
    ? FTTC_BANDWIDTH_PROFILES.SOG6028_ENABLED
    : FTTC_BANDWIDTH_PROFILES.DEFAULT;
  //return isSOG6028Enabled ? FTTC_BANDWIDTH_PROFILES.DEFAULT : FTTC_BANDWIDTH_PROFILES.DEFAULT;
}

export const NBN_ASSURE_ALLOWED_SPEED = [
  "50/20 Mbps",
  "100/20 Mbps",
  "100/40 Mbps",
  "750/50 Mbps",
  "250/100 Mbps",
  "500/50 Mbps",
  "500/200 Mbps",
  "1000/100 Mbps",
  "1000/400 Mbps"
];

export const COS_HIGH_BANDWIDTH = [
  { text: "10 Mbps", value: "10 Mbps", disabled: false },
  { text: "20 Mbps", value: "20 Mbps", disabled: false },
  { text: "30 Mbps", value: "30 Mbps", disabled: false },
  { text: "40 Mbps", value: "40 Mbps", disabled: false },

  { text: "50 Mbps", value: "50 Mbps", disabled: false },
  { text: "60 Mbps", value: "60 Mbps", disabled: false },
  { text: "70 Mbps", value: "70 Mbps", disabled: false },
  { text: "80 Mbps", value: "80 Mbps", disabled: false },

  { text: "90 Mbps", value: "90 Mbps", disabled: false },
  { text: "100 Mbps", value: "100 Mbps", disabled: false },
  { text: "150 Mbps", value: "150 Mbps", disabled: false },
  { text: "200 Mbps", value: "200 Mbps", disabled: false },

  { text: "250 Mbps", value: "250 Mbps", disabled: false },
  { text: "300 Mbps", value: "300 Mbps", disabled: false },
  { text: "350 Mbps", value: "350 Mbps", disabled: false },
  { text: "400 Mbps", value: "400 Mbps", disabled: false },

  { text: "450 Mbps", value: "450 Mbps", disabled: false },
  { text: "500 Mbps", value: "500 Mbps", disabled: false },
  { text: "600 Mbps", value: "600 Mbps", disabled: false },
  { text: "700 Mbps", value: "700 Mbps", disabled: false },

  { text: "800 Mbps", value: "800 Mbps", disabled: false },
  { text: "900 Mbps", value: "900 Mbps", disabled: false },
  { text: "1000 Mbps", value: "1000 Mbps", disabled: false },
  { text: "2000 Mbps", value: "2000 Mbps", disabled: false },

  { text: "3000 Mbps", value: "3000 Mbps", disabled: false },
  { text: "4000 Mbps", value: "4000 Mbps", disabled: false },
  { text: "5000 Mbps", value: "5000 Mbps", disabled: false },
  { text: "6000 Mbps", value: "6000 Mbps", disabled: false },

  { text: "7000 Mbps", value: "7000 Mbps", disabled: false },
  { text: "8000 Mbps", value: "8000 Mbps", disabled: false },
  { text: "9000 Mbps", value: "9000 Mbps", disabled: false },
  { text: "10000 Mbps", value: "10000 Mbps", disabled: false }
];

export const OVC_TRANSIENT_ID = [
  { text: "OVC-1", value: "OVC-1", disabled: false },
  { text: "OVC-2", value: "OVC-2", disabled: false },
  { text: "OVC-3", value: "OVC-3", disabled: false },
  { text: "OVC-4", value: "OVC-4", disabled: false },
  { text: "OVC-5", value: "OVC-5", disabled: false },
  { text: "OVC-6", value: "OVC-6", disabled: false },
  { text: "OVC-7", value: "OVC-7", disabled: false },
  { text: "OVC-8", value: "OVC-8", disabled: false }
];
